/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { DATA_LAYER_EVENTS, REGISTRATION_STATUSES } from 'components/common/constants';
import PopUpSuccessScheme from 'components/common/PopUpScheme/PopUpSuccessScheme';
import i18nContext from 'components/i18n-context';
import { ROUTE_PATHS } from 'routes/constants';
import { pushDataLayerEvent } from 'services/analytics';
import { getCustomerId, getCustomerType, getInternalUserId, setIsSuccessLoginStatus } from 'services/authUtils';
import { PopUp } from 'uikit/PopUp/PopUp';
import '../RegistrationStyles.scss';

const SuccessAccountRegistration = ({ registrationStore, userStore }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const i18n = useContext(i18nContext);

  useEffect(() => {
    if (
      location.pathname === ROUTE_PATHS.REGISTRATION_SUCCESS &&
      registrationStore.registrationStatus !== REGISTRATION_STATUSES.REGISTRATION_STATUS_CONFIRMED
    ) {
      navigate(ROUTE_PATHS.REGISTRATION);
    } else if (userStore?.userData?.availableAccounts && userStore?.userData?.availableAccounts?.length > 0) {
      pushDataLayerEvent(DATA_LAYER_EVENTS.REGISTRATION_SUCCESS_ADDITIONAL, {
        user_id_internal: getInternalUserId(),
        customer_id: getCustomerId(),
        customer_type: getCustomerType()
      });
    } else {
      pushDataLayerEvent(DATA_LAYER_EVENTS.REGISTRATION_SUCCESS, {
        user_id_internal: getInternalUserId(),
        customer_id: getCustomerId(),
        customer_type: getCustomerType()
      });
    }
  }, []);

  const onPopUpClose = async () => {
    if (!registrationStore.isAfterUserRegistration) {
      await userStore.loadUserData(null, true);
    } else {
      setIsSuccessLoginStatus(true);
    }
    navigate(ROUTE_PATHS.VERIFICATION);
    registrationStore.resetRegistrationStore();
  };

  return (
    <PopUp show={true}>
      <PopUpSuccessScheme
        onClose={onPopUpClose}
        message={i18n.getMessage('popUp.success.registration')}
        buttonText={i18n.getMessage('popUp.success.button')}
      />
    </PopUp>
  );
};

SuccessAccountRegistration.propTypes = {
  registrationStore: MobXPropTypes.observableObject,
  userStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  registrationStore: stores.registrationStore,
  userStore: stores.userStore
}))(observer(SuccessAccountRegistration));
